import React, { useState, useEffect } from 'react'
import styles from './ProjectsFilter.module.scss'
import { Button, ScrollableContainer } from 'components/common'
import FilterSection from './FilterSection'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { PROJECT_STORE, ProjectStore } from 'store'
import { toJS } from 'mobx'
import DateFilter from './DateFilter'
import { GenreTypes, StatusTypes } from 'models'

interface Props {
  closeModal: () => void;
  [PROJECT_STORE]?: ProjectStore;
}

const ProjectsFilter = (props: Props) => {
  const {
    closeModal,
    [PROJECT_STORE]: {
      genresFilter,
      statusFilter,
      dateAddedPeriodFilter,
      setFilters
    }
  } = props

  const [genresFilterState, setGenresFilterState] = useState([])
  const [statusFilterState, setStatusFilterState] = useState([])
  const [period, setPeriod] = useState(null)

  useEffect(() => {
    setGenresFilterState(toJS(genresFilter))
    setStatusFilterState(toJS(statusFilter))
    setPeriod(toJS(dateAddedPeriodFilter))
  }, [genresFilter, statusFilter, dateAddedPeriodFilter])

  const onApply = () => {
    setFilters(genresFilterState, statusFilterState, period)
    closeModal()
  }

  return (
    <div className={styles.container}>

      <ScrollableContainer className={styles.body}>
        <FilterSection
          title='genre'
          options={Object.values(GenreTypes)}
          selectedOptions={genresFilterState}
          setSelected={setGenresFilterState}
        />
        <FilterSection
          title='status'
          options={Object.values(StatusTypes)}
          selectedOptions={statusFilterState}
          setSelected={setStatusFilterState}
        />
        <DateFilter
          period={period}
          setPeriod={setPeriod}
        />
      </ScrollableContainer>

      <div className={styles.buttonsContainer}>
        <Button
          type='cancel'
          size='mini'
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          size='mini'
          onClick={onApply}
        >
          Apply
        </Button>
      </div>

    </div>
  )
}

export default inject(PROJECT_STORE)(observer(ProjectsFilter))
